import React, { lazy, Suspense, useEffect } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import AuthService from './services/AuthService'
import { Actions } from './redux/actions/action'
import './scss/style.scss'

const loading = (
  <div className='pt-3 text-center'>
    <div className='sk-spinner sk-spinner-pulse'></div>
  </div>
)

const Layout = lazy(() => import('./layout/Layout'))

const App = () => {
  const dispatch = useDispatch()
  // Background token refresh to maintain session for idle users
  useEffect(() => {
    // Refresh token every 4 minutes (240 seconds)
    // With 5-min access tokens, this ensures token is refreshed before expiry. HBGPPH-2134
    const refreshInterval = setInterval(() => {
      AuthService.updateToken((refreshed) => {
        if (refreshed) {
          dispatch({
            type: Actions.USER_DETAILS.UPDATE_USER,
            payload: AuthService.getUser()
          })
        }
        return refreshed
      })
    }, 240000) // 4 minutes

    // Cleanup interval on component unmount
    return () => clearInterval(refreshInterval)
  }, [dispatch])

  return (
    <HashRouter>
      <Suspense fallback={loading}>
        <Routes>
          <Route path='*' element={<Layout />} />
        </Routes>
      </Suspense>
    </HashRouter>
  )
}

export default App
